// extracted by mini-css-extract-plugin
module.exports = {"table":"AdminLogItem_table__1aDuU","row":"AdminLogItem_row__18BXg","head":"AdminLogItem_head__2jlr8","td":"AdminLogItem_td__1xBQf","th":"AdminLogItem_th__l5Fa-"};